import type { ElitePlansPrimaryCtaDisplay } from '../../../elitePlansPrimaryCtaDisplay'
import { ElitePlansEventId, trackElitePlansClick } from '../../../analytics'
import type { EliteEventExtras } from '../../../../../utils/eliteEventExtras'

export type ElitePlansPrimaryCtaProps = {
  display: ElitePlansPrimaryCtaDisplay
  planId: string
  disabled?: boolean
  landingPageState?: string
  /** Buy-CTA analytics: `amount` + `cta_name` (separate from `planId`). */
  eventExtras?: EliteEventExtras
  onActivate?: () => void
  className?: string
}

export function ElitePlansPrimaryCta({
  display,
  planId,
  disabled = false,
  landingPageState,
  eventExtras,
  onActivate,
  className = 'mt-8'
}: ElitePlansPrimaryCtaProps) {
  const handleClick = () => {
    if (disabled) return
    trackElitePlansClick(ElitePlansEventId.CtaClick, {
      planId,
      buttonLabel: display.label,
      landingPageState: landingPageState ?? '',
      ...eventExtras
    })
    onActivate?.()
  }

  return (
    <button
      type='button'
      onClick={handleClick}
      disabled={disabled}
      className={`ep-motion ep-theme-tween flex min-h-[56px] w-full items-center justify-center rounded-xl bg-[color:var(--ep-cta)] px-5 text-[15px] font-medium text-[color:var(--ep-cta-text)] transition-[filter] duration-150 hover:brightness-95 active:brightness-90 disabled:opacity-40 disabled:hover:brightness-100 disabled:active:brightness-100 ${className}`}
    >
      {display.variant === 'elite-prime-priced' ? (
        <>
          {display.prefix}
          {display.struckPrice ? (
            <span className='mx-1.5 line-through opacity-50'>{display.struckPrice}</span>
          ) : null}
          {display.price}
          <span className='text-[color:var(--ep-cta-suffix)]'>{display.feeSuffix}</span>
        </>
      ) : (
        display.label
      )}
    </button>
  )
}
